import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import {router} from "../main.js";
import Cookies from "js-cookie";

Vue.use(Vuex);
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;

export const store = new Vuex.Store({
	state: {
		token: localStorage.getItem("access_token") || null,
		tokenNacional: localStorage.getItem("access_token_nacional") || null,
		usuarioId: localStorage.getItem("usuario_id") || null,
		usuarioNombre: localStorage.getItem("usuario_nombre") || null,
		usuarioIniciales: localStorage.getItem("usuario_iniciales") || null,
		erroresRegistro: [],
		erroresLogin: [],
		erroresRecuperarPw: [],
		erroresResetearPw: [],
		erroresUsuario: [],
		cargando: false,
		ticketsPropiedades: JSON.parse(localStorage.getItem("tickets_prop")) || null,
		trnFechaFin: localStorage.getItem("trn_end_time") || null,
		menuOpened: false,
	},
	getters: {
		loggedIn(state) {
			return state.token !== null;
		},
		isMenuOpened(state) {
			return state.menuOpened;
		},
	},
	mutations: {
		cargando(state, isCargando) {
			state.cargando = isCargando;
		},
		retrieveToken(state, token) {
			state.token = token;
		},
		destroyToken(state) {
			state.token = null;
		},
		setearTokenNacional(state, token) {
			state.tokenNacional = token;
		},
		destruirTokenNacional(state) {
			state.tokenNacional = null;
		},
		setearNombre(state, nombre) {
			state.usuarioNombre = nombre;
		},
		setearIniciales(state, iniciales) {
			state.usuarioIniciales = iniciales;
		},
		setearUsuarioId(state, usuarioId) {
			state.usuarioId = usuarioId;
		},
		destruirNombre(state) {
			state.usuarioNombre = null;
		},
		destruirIniciales(state) {
			state.usuarioIniciales = null;
		},
		destruirUsuarioId(state) {
			state.usuarioId = null;
		},
		insertarErrorRegistro(state, error) {
			state.erroresRegistro = [];
			state.erroresRegistro.push({msg: error});
		},
		limpiarErroresRegistro(state) {
			state.erroresRegistro = [];
		},
		insertarErrorLogin(state, error) {
			state.erroresLogin = [];
			state.erroresLogin.push({msg: error});
		},
		limpiarErroresLogin(state) {
			state.erroresLogin = [];
		},
		insertarErrorRecuperarPw(state, error) {
			state.erroresRecuperarPw = [];
			state.erroresRecuperarPw.push({msg: error});
		},
		limpiarErroresRecuperarPw(state) {
			state.erroresRecuperarPw = [];
		},
		insertarErrorResetearPw(state, error) {
			state.erroresResetearPw = [];
			state.erroresResetearPw.push({msg: error});
		},
		limpiarErroresResetearPw(state) {
			state.erroresResetearPw = [];
		},
		insertarErrorUsuario(state, error) {
			state.erroresUsuario = [];
			state.erroresUsuario.push({msg: error});
		},
		limpiarErroresUsuario(state) {
			state.erroresUsuario = [];
		},
		setearTicketsPropiedades(state, ticketsPropiedades) {
			state.ticketsPropiedades = ticketsPropiedades;
		},
		limpiarTicketsPropiedades(state) {
			state.ticketsPropiedades = null;
		},
		setearTrnFechaFin(state, trnFechaFin) {
			state.trnFechaFin = trnFechaFin;
		},
		limpiarTrnFechaFin(state) {
			state.trnFechaFin = null;
		},
		setearMenuOpened(state, menuOpened) {
			state.menuOpened = menuOpened;
		},
	},
	actions: {
		cargando(context, isCargando) {
			context.commit("cargando", isCargando);
		},
		actualizarNombre(context, datoNombre) {
			return new Promise((resolve, reject) => {
				localStorage.setItem("usuario_nombre", datoNombre.nombre);
				context.commit("setearNombre", datoNombre.nombre);
			});
		},
		actualizarMenuOpened(context, menuOpened) {
			return new Promise((resolve, reject) => {
				context.commit("setearMenuOpened", menuOpened);
			});
		},
		async retrieveToken(context, credentials) {
			return new Promise((resolve, reject) => {
				// Consumo web service de token mediante Axios
				axios
					.post("/WSIniciarSesion", {
						UsuarioEmail: credentials.email,
						UsuarioPassword: credentials.password,
						JWTClienteId: 1,
					})
					.then((response) => {
						if (response.data.ErrorCod === 0) {
							// Guardo token que devuelve el ws en el LocalStorage
							const token = response.data.JWTAccesoId;
							localStorage.setItem("access_token", token);
							var usuarioId = response.data.UsuarioId;
							localStorage.setItem("usuario_id", usuarioId);
							var nombre = response.data.UsuarioPersonaNombre;
							localStorage.setItem("usuario_nombre", nombre);
							var iniciales = response.data.UsuarioPersonaIniciales;
							localStorage.setItem("usuario_iniciales", iniciales);
							context.commit("retrieveToken", token);
							context.commit("setearNombre", nombre);
							context.commit("setearIniciales", iniciales);
							context.commit("setearUsuarioId", usuarioId);
							resolve(response);
						} else {
							var responseError = response.data.ErrorDsc;
							context.commit("insertarErrorLogin", responseError);
							reject();
						}
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
		async replicarSesion(context, data) {
			try {
				// Guardo token que devuelve el ws en el LocalStorage
				const token = data.JWTAccesoId;
				localStorage.setItem("access_token", token);
				var usuarioId = data.UsuarioId;
				localStorage.setItem("usuario_id", usuarioId);
				var nombre = data.UsuarioPersonaNombre;
				localStorage.setItem("usuario_nombre", nombre);
				var iniciales = data.UsuarioPersonaIniciales;
				localStorage.setItem("usuario_iniciales", iniciales);
				context.commit("retrieveToken", token);
				context.commit("setearNombre", nombre);
				context.commit("setearIniciales", iniciales);
				context.commit("setearUsuarioId", usuarioId);
			} catch (error) {
				window.location.href = process.env.VUE_APP_URL_NACIONALUY;
			}
		},
		destroyToken(context) {
			if (context.getters.loggedIn) {
				return new Promise((resolve, reject) => {
					localStorage.removeItem("access_token");
					localStorage.removeItem("access_token_nacional");
					localStorage.removeItem("usuario_nombre");
					localStorage.removeItem("usuario_iniciales");
					localStorage.removeItem("usuario_id");
					context.commit("destroyToken");
					context.commit("destruirTokenNacional");
					context.commit("destruirNombre");
					context.commit("destruirIniciales");
					context.commit("destruirUsuarioId");
					resolve();
				});
			}
		},
		setTokenNacional(context, token) {
			if (token) {
				localStorage.setItem("access_token_nacional", token);
				context.commit("setearTokenNacional", token);
			}
		},
		registrarUsuario(context, datosUsuario) {
			return new Promise((resolve, reject) => {
				// Consumo web service de registro mediante Axios
				axios
					.post("/WSRegistro", {
						UsuarioEmail: datosUsuario.email,
						UsuarioPassword: datosUsuario.password,
						PersonaNombre: datosUsuario.nombre,
						PersonaApellido: datosUsuario.apellido,
						PersonaDocumentoTipoId: datosUsuario.documentoTipo,
						PersonaDocumento: datosUsuario.documento,
						PersonaTelefono: datosUsuario.telefono,
						PersonaSocioNro: datosUsuario.socioNro,
						PersonaButacaNro: datosUsuario.butacaNro,
					})
					.then((response) => {
						if (response.data.ErrorCod === 0) {
							resolve(response);
						} else {
							var responseError = response.data.ErrorDsc;
							context.commit("insertarErrorRegistro", responseError);
							reject();
						}
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
		recuperarPassword(context, datos) {
			return new Promise((resolve, reject) => {
				// Consumo ws de recuperación de contraseña
				axios
					.post("/WSResetPasswordEmail", {
						UsuarioEmail: datos.email,
					})
					.then((response) => {
						if (response.data.ErrorCod === 0) {
							resolve(response);
						} else {
							var responseError = response.data.ErrorDsc;
							context.commit("insertarErrorRecuperarPw", responseError);
							reject();
						}
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
		resetearPassword(context, datos) {
			return new Promise((resolve, reject) => {
				// Consumo ws de reseteo de contraseña
				axios
					.post("/WSResetPassword", {
						ActivacionGUID: datos.hashVerificacion,
						NuevaPassword: datos.password,
					})
					.then((response) => {
						if (response.data.ErrorCod === 0) {
							resolve(response);
						} else {
							var responseError = response.data.ErrorDsc;
							context.commit("insertarErrorResetearPw", responseError);
							reject(response.data.ErrorDsc);
						}
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
		actualizarUsuario(context, datosUsuario) {
			return new Promise((resolve, reject) => {
				// Consumo web service de actualización mediante Axios
				var tokenActualizado = localStorage.getItem("access_token");
				axios
					.post(
						"/WSActualizarUsuario",
						{
							UsuarioId: datosUsuario.usuarioId,
							PersonaId: datosUsuario.personaId,
							PersonaNombre: datosUsuario.nombre,
							PersonaApellido: datosUsuario.apellido,
							PersonaDocumentoTipoId: datosUsuario.documentoTipo,
							PersonaDocumento: datosUsuario.documento,
							PersonaTelefono: datosUsuario.telefono,
							PersonaSocioNro: datosUsuario.socioNro,
							PersonaButacaNro: datosUsuario.butacaNro,
							PersonaFchNacimiento: datosUsuario.fchNacimiento,
							PaisId: datosUsuario.pais,
							GeoDiv1Id: datosUsuario.departamento,
							GeoDiv2Id: datosUsuario.ciudad,
							PersonaGenero: datosUsuario.genero,
						},
						{
							headers: {Authorization: "Bearer " + tokenActualizado},
						}
					)
					.then((response) => {
						if (response.data.ErrorCod === 1) {
							localStorage.removeItem("access_token");
							localStorage.removeItem("access_token_nacional");
							localStorage.removeItem("usuario_nombre");
							localStorage.removeItem("usuario_iniciales");
							localStorage.removeItem("usuario_id");
							context.commit("destroyToken");
							context.commit("destruirTokenNacional");
							context.commit("destruirNombre");
							context.commit("destruirIniciales");
							context.commit("destruirUsuarioId");

							router.push({name: "login"});
						} else {
							if (response.data.ErrorCod === 0) {
								resolve(response);
							} else {
								var responseError = response.data.ErrorDsc;
								context.commit("insertarErrorUsuario", responseError);
								reject();
							}
						}
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
		validarToken(context, data) {
			return new Promise((resolve, reject) => {
				var tokenActualizado = localStorage.getItem("access_token");
				axios
					.post(
						"/WSValidarToken",
						{
							UsuarioId: data.usuarioId,
						},
						{
							headers: {Authorization: "Bearer " + tokenActualizado},
						}
					)
					.then((response) => {
						if (response.data.ErrorCod !== 0) {
							Cookies.remove("isqueuevip");
							dispatch("destroyToken");
						} else {
							if (response.data.ErrorDsc) {
								Cookies.set("isqueuevip", response.data.ErrorDsc, {sameSite: "Strict"});
							} else {
								Cookies.remove("isqueuevip");
							}
							resolve(response);
						}
					})
					.catch((error) => {
						Cookies.remove("isqueuevip");
						reject(error);
					});
			});
		},
		setearTicketsPropiedades(context, ticketsPropiedades) {
			return new Promise((resolve, reject) => {
				localStorage.setItem("tickets_prop", JSON.stringify(ticketsPropiedades));
				context.commit("setearTicketsPropiedades", ticketsPropiedades);
			});
		},
		limpiarTicketsPropiedades(context) {
			return new Promise((resolve, reject) => {
				localStorage.removeItem("tickets_prop");
				context.commit("limpiarTicketsPropiedades");
				resolve();
			});
		},
		setearTrnFechaFin(context, trnFechaFin) {
			return new Promise((resolve, reject) => {
				localStorage.setItem("trn_end_time", trnFechaFin);
				context.commit("setearTrnFechaFin", trnFechaFin);
			});
		},
		limpiarTrnFechaFin(context) {
			return new Promise((resolve, reject) => {
				localStorage.removeItem("trn_end_time");
				context.commit("limpiarTrnFechaFin");
				resolve();
			});
		},
		mostrarSuccess(context, msj) {
			return new Promise((resolve, reject) => {
				this._vm.$toast.success(msj, {
					position: "bottom-left",
					timeout: 6000,
					closeOnClick: true,
					pauseOnFocusLoss: false,
					pauseOnHover: true,
					draggable: false,
					draggablePercent: 0.6,
					showCloseButtonOnHover: true,
					hideProgressBar: true,
					closeButton: "button",
					icon: true,
					rtl: false,
				});

				resolve();
			});
		},
		mostrarError(context, err) {
			return new Promise((resolve, reject) => {
				this._vm.$toast.error(err, {
					position: "bottom-left",
					timeout: 6000,
					closeOnClick: true,
					pauseOnFocusLoss: false,
					pauseOnHover: true,
					draggable: false,
					draggablePercent: 0.6,
					showCloseButtonOnHover: true,
					hideProgressBar: true,
					closeButton: "button",
					icon: true,
					rtl: false,
				});

				resolve();
			});
		},
	},
});
